import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import AdminStaff from "./stafflist";
import AdminClaims from "./claims";
import AdminSetup from "./practicesetup";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    boxShadow: 'none',
    backgroundColor: '#eaeaea',
    color: 'black',
  }
});

class Admin extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  constructor(props){
      super(props);
      this.props=props;
      
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    
    return (
      
        <div>
          <AppBar position="static" className={classes.tabBar}>
            <Tabs value={value} onChange={this.handleChange}>
              <Tab label="Staff"/>
              <Tab label="Claims"/>
              <Tab label="Practice Setup"/>
            </Tabs>
          </AppBar>     
          {value === 0 && <TabContainer><AdminStaff socket={this.props.socket} authenticator={this.props.authenticator}/></TabContainer>}
          {value === 1 && <TabContainer><AdminClaims socket={this.props.socket}/></TabContainer>}
          {value === 2 && <TabContainer><AdminSetup socket={this.props.socket}/></TabContainer>}
        </div>
    );
  }
}           

export default withStyles(styles)(Admin);